export default __webpack_public_path__ + "static/tools-12ba205eea467f8fc7ad666c82d3ef71.svg";